import React, { useEffect, useRef } from 'react';
import { AppHeader } from 'templates/AppHeader';
import { MypageMenuBar } from './MypageMenuBar';
import { Fade } from '@mui/material';

type TopMenuProps = {
  isSp: boolean;
};

export const TopMenu: React.FC<TopMenuProps> = ({ isSp }) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = React.useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setIsVisible(entry.isIntersecting);
    });

    if (menuRef.current) {
      observer.observe(menuRef.current);
    }

    return () => {
      if (menuRef.current) {
        observer.unobserve(menuRef.current);
      }
    };
  }, []);

  if (isSp) {
    return <AppHeader />;
  }
  return (
    <div ref={menuRef}>
      <MypageMenuBar />
      <Fade in={!isVisible}>
        <div>
          <AppHeader />
        </div>
      </Fade>
    </div>
  );
};
